import {IController, ITimeoutService, IWindowService} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../../tasks/models/task.model";


export class leanPlanningRoutesPrintPageCtrl implements IController {
  routes: any;
  serviceAreas: any;

  public currentDate: any;
  public logoUrl: any;
  public displayExternal: any;
  public hasDisplayIdColumn: any;
  public serviceAreasMap: any;

  constructor(private splitService: SplitService, private $window: IWindowService, private $timeout: ITimeoutService, private moment) {
  }

  $onInit() {
    this.currentDate = this.moment().valueOf();
    this.logoUrl = this.splitService.getSiteLogoUrl();
    this.displayExternal = this.splitService.getSiteExternalIdConfig();
    this.hasDisplayIdColumn = this._routesHasDisplayIdColumn(this.routes);
    this.serviceAreasMap = _.keyBy(this.serviceAreas.list, 'id');
  };

  $postLink() {
    this.$timeout(1000).then(() => {
      this.$window.print();
      this.$window.close();
    })
  };

  private _routesHasDisplayIdColumn(routes) {
    return _.findIndex(routes, (r: any) => {
      return _.findIndex(r.taskListExt, (task: TaskModel) => {
        return !!task.serviceDisplayId;
      }) > -1;
    }) > -1;
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('leanPlanningRoutesPrintPage', {
    bindings: {
      routes: '<',
      serviceAreas: '<'
    },
    template: require('./lean-planning-routes-print-page.html').default,
    controller: leanPlanningRoutesPrintPageCtrl
  });
